"use client";

import React from "react";

import classNames from "classnames";

import { Card } from "@/components/flowbite/card";

import { SectionTitle } from "../section-title";
import { SkeletonBox } from "../skeleton-box";
import styles from "../summary-metrics.module.css";

interface ClusterSelectionSummarySkeletonProps {
  metricCount: 1 | 2 | 3 | 4;
  /** Students tile spans full width on wide 3-tile layouts. */
  studentsFullWidth?: boolean;
}

export const ClusterSelectionSummarySkeleton: React.FC<
  ClusterSelectionSummarySkeletonProps
> = ({ metricCount, studentsFullWidth = metricCount === 3 }) => {
  const isSingleMetric = metricCount === 1;

  return (
    <div className={styles.summaryMetrics}>
      <SectionTitle title="Summary" />
      <div
        className={classNames(
          styles.summaryMetricsGrid,
          isSingleMetric ? styles.summaryMetricsGridSingle : styles.summaryMetricsGridWide,
        )}
      >
        {Array.from({ length: metricCount }, (_, index) => (
          <Card
            key={index}
            className={classNames(
              "flex flex-col gap-2 border-none bg-gray-100 p-2",
              {
                [styles.summaryMetricFullWidth]: studentsFullWidth && index === 0,
              },
            )}
          >
            <div className="flex gap-2">
              <SkeletonBox className="h-8 w-12" />
              <SkeletonBox className="h-6 w-6 shrink-0 rounded" />
            </div>
            <SkeletonBox className="h-4 w-16" />
          </Card>
        ))}
      </div>
    </div>
  );
};
